﻿cb.define([], function () {
  var ST_st_storechecklist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      // ====== 共用变量 ======
    	var self = this;
      var checkInventorySheetGenerate = false;

    	viewmodel.on("beforeBatchdelete",function(args){
    		var rowIndex = args.params.params.index;
        return self.beforeDelete(viewmodel, rowIndex);
      });

      viewmodel.on("beforeEdit",function(args){
    		var rowIndex = args.params.params.index;
        return self.beforeEdit(viewmodel, rowIndex);
      });

      // viewmodel.on("beforeAdd",function(args){
      //   var ret = true;
      //   var rows = viewmodel.getGridModel().getRows();
      //   var rowLength = rows.length;
      //
      //   for (var i = 0; i < rowLength; i++) {
      //     if (rows[i].status != 1) {
      //       cb.utils.alert("尚有未审核的盘点单，不能新增！", 'error');
      //       ret = false;
      //       break;
      //     }
      //   }
      //
      //   return ret;
      // });

      //联查其他出库单
      viewmodel.on('queryothout', function (args) {
        var selectRow = viewmodel.getGridModel().getData()[args.params.index];
        var originid = selectRow.id;
        var proxy = cb.rest.DynamicProxy.create({ensure: {url: args.cSvcUrl, method: args.cHttpMethod}});
        var params = {
          action: 'queryothout',
          billnum: 'st_storecheck',
          data: JSON.stringify(originid)
        }
        proxy.ensure(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
          if (result != undefined) {
            // cb.utils.alert('操作成功', 'success');
            viewmodel.execute('refresh');
            var params = {
              mode: 'edit',
              readOnly: true,
              id: JSON.parse(result).id
            };
            var data = {
              billtype: 'voucher',
              billno: JSON.parse(result).billno,
              params: params
            };
            cb.loader.runCommandLine('bill', data, viewmodel);
          }
        });
      });

      //联查其他入库单
      viewmodel.on('queryothin', function (args) {
        var selectRow = viewmodel.getGridModel().getData()[args.params.index];
        var originid = selectRow.id;
        var proxy = cb.rest.DynamicProxy.create({ensure: {url: args.cSvcUrl, method: args.cHttpMethod}});
        var params = {
          action: 'queryothin',
          billnum: 'st_storecheck',
          data: JSON.stringify(originid)
        };
        proxy.ensure(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
          if (result != undefined) {
            // cb.utils.alert('操作成功', 'success');
            viewmodel.execute('refresh');
            var params = {
              mode: 'edit',
              readOnly: true,
              id: JSON.parse(result).id
            };
            var data = {
              billtype: 'voucher',
              billno: JSON.parse(result).billno,
              params: params
            };
            cb.loader.runCommandLine('bill', data, viewmodel);
          }
        });
      });

      viewmodel.on('dochecking', function (args) {
        var selectRow = viewmodel.getGridModel().getData()[args.params.index];
        var originid = selectRow.id;
        viewmodel.getGridModel().execute('dblClick', {id:originid});
        return;
      });

      viewmodel.on('submit', function (args) {
        var gridModel = viewmodel.getGridModel();
        var selectRow = gridModel.getData()[args.params.index];

        gridModel.setActionState(args.params.index, 'btnRowAudit', 'visible', false);

        var proxy = cb.rest.DynamicProxy.create({ensure: {url: args.cSvcUrl, method: args.cHttpMethod}});
        var params = {
          action: 'scSubmit',
          billnum: 'st_storechecklist',
          data: JSON.stringify(selectRow)
        };

        proxy.ensure(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            gridModel.setActionState(args.params.index, 'btnRowAudit', 'visible', true);
            return;
          }

          cb.utils.alert('盘点单提交成功！', 'success');
          viewmodel.execute('refresh');
        });
      });

      viewmodel.on('unsubmit', function (args) {
        var gridModel = viewmodel.getGridModel();
        var selectRow = gridModel.getData()[args.params.index];

        gridModel.setActionState(args.params.index, 'btnUnaudit', 'visible', false);

        var proxy = cb.rest.DynamicProxy.create({ensure: {url: args.cSvcUrl, method: args.cHttpMethod}});
        var params = {
          action: 'scUnSubmit',
          billnum: 'st_storechecklist',
          data: JSON.stringify(selectRow)
        };

        proxy.ensure(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            gridModel.setActionState(args.params.index, 'btnUnaudit', 'visible', true);
            return;
          }

          cb.utils.alert('成功将盘点单退回复盘！', 'success');
          viewmodel.execute('refresh');
        });
      });

      viewmodel.getGridModel().on('beforeSetActionsState', function (args) {
        // ====== 查询参数：是否升单 ======
        var queryOptionProxy = cb.rest.DynamicProxy.create({
          settle: {
            url: '/option/getOptionsByParams?token=28f9169d2e2a491bb1804138e4357e29',
            method: 'POST'
          }
        });

        var params = {
          optionId: 'business_option',
          name: 'checkInventorySheetGenerate',
          groupCode: 'bo0102'
        };

        queryOptionProxy.settle(params, (err, result) => {
          if (err) {
            return;
          }

          if(result === undefined) {
            return;
          }

          if (result.length > 0) {
            checkInventorySheetGenerate = result[0].value;
          } else{
            checkInventorySheetGenerate = false;
          }

          var gridModel = viewmodel.getGridModel();

          for (var i = 0; i < args.length; i++) {
            var selectRow = gridModel.getData()[i];
            var curStatus = selectRow.status;

            if (curStatus == 1) {
              var row = args[i];
              if (checkInventorySheetGenerate) {
                row.btnQueryOthOut.visible = true;
                row.btnQueryOthIn.visible = true;
              } else {
                row.btnQueryOthOut.visible = false;
                row.btnQueryOthIn.visible = false;
              }
            }
          }
        });
      });



    },

    beforeDelete: function(viewmodel, rowIndex){
      var currentRow = viewmodel.getGridModel().getRow(rowIndex);
      if (currentRow.status === 1) {
        cb.utils.alert("已审核的单据不允许删除！");
        return false;
      }
    },

    beforeEdit: function(viewmodel, rowIndex){
      var currentRow = viewmodel.getGridModel().getRow(rowIndex);
      if (currentRow.status === 1) {
        cb.utils.alert("已审核的单据不允许编辑！");
        return false;
      }
    }


  };
  try {
    module.exports = ST_st_storechecklist_VM_Extend;
  } catch (error) {

  }
  return ST_st_storechecklist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storechecklist_VM.Extend.js